// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"85":"391b01f9","99":"cf0ac474","114":"79754b44","197":"8a7283cc","271":"73914dc4","362":"f2889e84","385":"cd839559","400":"a6fbc6ac","477":"44ca04c3","566":"56035f7f","605":"1671a6b1","818":"5ff69c5f","823":"fd6d33b3","928":"376f9f5c","971":"8f1bdf83"}[chunkId] + ".chunk.js";
};